import { GetConfig } from "@/types/Api/Common/Home/getConfig";
import { create } from "zustand";
export * from "./localstorage";

interface ExampleStore {
  variable: number;
  increaseVar: (add: number) => void;
}

export const useExampleStore = create<ExampleStore>((set) => ({
  variable: 0,
  increaseVar: (add) => set((state) => ({ variable: (state.variable += add) })),
}));

interface ConfigStore {
  config: GetConfig["response"] | null;
  cdn: string | null;
  isH5Plus: boolean;
  waitingSellerCompletesOrderDelayTime: string;
  waitingSellerConfirmDelayTime: string;
  buyerPaysOvertimeDelayTime: string;
  ProfessionBuyerPaysOvertimeDelayTime: string;
  setConfig: (config: GetConfig["response"]) => void;
  setCDN: (cdn: string) => void;
}
export /* `const useConfigStore` 正在创建一个新的 Zustand 存储来管理配置数据。它使用一个空的 `config` 属性和一个 `setConfig`
函数初始化存储，用于使用新的配置对象更新 `config` 属性。 */
const useConfigStore = create<ConfigStore>((set) => ({
  config: null,
  cdn: null,
  isH5Plus:!!window.plus,
  waitingSellerCompletesOrderDelayTime: "0分钟",
  waitingSellerConfirmDelayTime: "0分钟",
  buyerPaysOvertimeDelayTime: "0分钟",
  ProfessionBuyerPaysOvertimeDelayTime:"0分钟",
  setConfig: (config: GetConfig["response"]) =>
    set(() => {
      const toStringDelayTime = (time: string) => {
        const mins = Number(time) / 60;
        const reminder = mins % 60;
        const modular = (mins - reminder) / 60;
        if (mins < 60) return `${mins}分钟`;
        return `${modular}小时` + (reminder > 0 ? `${reminder}分钟` : "");
      };

      return {
        config,
        waitingSellerCompletesOrderDelayTime: toStringDelayTime(
          config.market.waitingSellerCompletesOrderDelayTime
        ),
        waitingSellerConfirmDelayTime: toStringDelayTime(
          config.market.waitingSellerConfirmDelayTime
        ),
        buyerPaysOvertimeDelayTime: toStringDelayTime(
          config.market.buyerPaysOvertimeDelayTime
        ),
        ProfessionBuyerPaysOvertimeDelayTime: toStringDelayTime(
          config.market.ProfessionBuyerPaysOvertimeDelayTime
        ),
      };
    }),
  setCDN: (cdn: string) => set(() => ({ cdn })),
}));
